// extracted by mini-css-extract-plugin
module.exports = {"icon":"UiIcon_icon_2UEy2","colorInheritance":"UiIcon_colorInheritance_1vKIu"};